import { ApplicationConfig, importProvidersFrom } from "@angular/core";
import { provideRouter, withEnabledBlockingInitialNavigation } from "@angular/router";
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from "@angular/common/http";
import { routes } from "./app.routes";
import { provideAnimations } from "@angular/platform-browser/animations";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDialogModule } from "@angular/material/dialog";
import { NgxIntlTelInputModule } from "ngx-intl-tel-input";
import { AuthInterceptor } from "./_lib/service/auth.interceptor";
import { PerformanceInterceptor } from "./_lib/service/performance.interceptor";
import { provideClientHydration} from "@angular/platform-browser";

export const appConfig: ApplicationConfig = {
  providers: [
    provideClientHydration(),
    provideRouter(routes, withEnabledBlockingInitialNavigation()),
    importProvidersFrom(
      ReactiveFormsModule,
      MatDialogModule,
      NgxIntlTelInputModule,
      FormsModule
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PerformanceInterceptor,
      multi: true,
    },
    provideAnimations(),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
  ]
}